$(function () {
  //PLIK NIE BYŁ UŻYWANY, BO BYŁ ŹLE NAZWANY JAKO HOME.JS I NIE BYŁO DO NIEGO LINKU W INDEX !!!!!!!!
  //  ZAKOMENTOWAŁAM PONIŻSZE FUNKCJE, PONIEWAZ
  //I TAK NIE BYŁY UŻYWANE, A PO PODŁACZENIU PLIKU NP. NA SEKCJI ZMIEN PIEC BYŁA PODWOJNA PAGINACJA

  // buttonInitActions();
  // initSliders();
  // initForm();
  // initScrollBar();
  hideMainNewsTiles();
});

/* -------------------------------------------------------------- BUTTON ACTIONS --- */
function buttonInitActions() {
  if ($("[data-menuscroll]").length > 0 && $("body").hasClass("homepage")) {
    $("[data-menuscroll]").click(function (e) {
      e.preventDefault();

      scrollToObj($("" + $(this).attr("href")), 50, 600);

      if ($(window).width() < 992) {
        $("#toggleMobileMenu").removeClass("open");
        $("#mainPageNav").removeClass("opened");
      }
    });
  }

  //Link Container - change tab content
  $(".linkContainer .tabList button").click(function (e) {
    e.preventDefault();
    changeContent($(this), $(".linkContainer"));

    let $box = $("#" + $(this).data("category"));

    // Main content fade toggle
    $(".e-linkBox").removeClass("active").fadeOut(0);
    $box.fadeIn();

    // Slider elements on front page - list with link
    if (
      $(window).width() < 992 &&
      $box.find("[data-lnk-list-slider]:not(.slick-initialized)").length > 0
    ) {
      $box.find("[data-lnk-list-slider]").slick({
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      });
    }
  });
}

/* -------------------------------------------------------------- SLIDERS --- */

function initSliders() {
  sliderResultBox();

  // Video slider
  var swiperVideo = new Swiper("[data-video-slider]", {
    slidesPerView: 2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    a11y: {
      prevSlideMessage: "Poprzedni slajd",
      nextSlideMessage: "Następny slajd",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: "auto",
        loop: true,
      },
      580: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
        loop: false,
      },
    },
  });

  // Other services slider
  var swiperService = new Swiper("[data-services-slider]", {
    slidesPerView: 5,
    slidesPerGroup: 1,
    spaceBetween: 12,
    // loop: true,
    // autoplay: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    a11y: {
      prevSlideMessage: "Poprzedni slajd",
      nextSlideMessage: "Następny slajd",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 5,
      },
    },
  });

  if ($(window).width() < 992) {
    $(".tabList").slick({
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    });

    // Slider elements on front page - list with link
    $(".tabResult section").first().find("[data-lnk-list-slider]").slick({
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    });
  }
}

/* -------------------------------------------------------------- FORM --- */
function initForm() {}

/* -------------------------------------------------------------- MAP --- */

/* -------------------------------------------------------------- SCROLLBAR --- */

function initScrollBar() {}

/* -------------------------------------------------------------- FUNCTION --- */

function sliderResultBox() {
  var swiperResultBox = new Swiper("[data-resultBox-slider]", {
    slidesPerView: 4,
    loopedSlides: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    a11y: {
      prevSlideMessage: "Poprzedni slajd",
      nextSlideMessage: "Następny slajd",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });
}

function changeContent($this, $obj) {
  scrollToObj($obj, 20, 600);

  // Toggle active class
  var category = $this.data("category");
  $obj.find("button").removeClass("active");
  $("button[data-category=" + category + "]").addClass("active");

  // Move slider on button click
  if ($(window).width() < 992) {
    var index = $this.parent().data("slick-index");
    $(".tabList").slick("slickGoTo", index);
  }
}

function addSublistClass($obj) {
  $obj.find("[data-expanded-sublist]").each(function () {
    if ($(this).outerHeight() > 235 && $(window).width() < 768) {
      $(this).addClass("scrollY");
    }
  });

  $("[data-expanded-sublist]").slideUp();
}

function hideMainNewsTiles() {
  if ($(window).width() > 991) {
    if ($(".mainNews [data-hidden-link]").length > 3) {
      let listItems = $(".mainNews [data-hidden-link] li");

      listItems.each(function (index, element) {
        if (index > 2) {
          $(element).addClass("hideDesktop");
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Sprawdź, czy na stronie istnieje element z atrybutem [data-smartcity-slider]
  const smartCitySlider = document.querySelector("[data-smartcity-slider]");

  if (smartCitySlider) {
    // Jeśli istnieje, zniszcz instancję Splide
    const splideInstance = new Splide(".splide", {
      pagination: false, // Wyłączenie paginacji
      arrows: false, // Wyłączenie strzałek
    });

    // Zatrzymaj działanie slidera na tej stronie
    splideInstance.destroy();
  }
});